import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from "@tanstack/react-query";
import { api } from "@/api/client";
import type {
  DataResponse,
  GlobalNastavenia,
  GlobalNastaveniaUpdate,
} from "@/api/schemas";

const KEY = ["nastavenia-global"] as const;

export function useNastaveniaGlobal(): UseQueryResult<
  DataResponse<GlobalNastavenia>
> {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get<DataResponse<GlobalNastavenia>>(
        "/nastavenia-global",
      );
      return data;
    },
    staleTime: 60_000,
  });
}

export function useUpdateNastaveniaGlobal(): UseMutationResult<
  DataResponse<GlobalNastavenia>,
  Error,
  GlobalNastaveniaUpdate
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.patch<DataResponse<GlobalNastavenia>>(
        "/nastavenia-global",
        payload,
      );
      return data;
    },
    // Nadmiera hrany vstupuje do všetkých cien — invaliduj všetko,
    // nech sa breakdowny zákaziek prepočítajú s novou hodnotou.
    onSuccess: () => void qc.invalidateQueries(),
  });
}
